export const cardStyles = {
  selected: {
    backgroundColor: 'var(--ql-color-accent1-t-lighten6)',
    border: '1px solid var(--ql-color-accent1-t-lighten4)'
  },
  default: { border: '1px solid transparent' }
}
